export default __webpack_public_path__ + "static/media/desk.33ea14d9.svg";